import Switch from '@components/FormComponents/Switch';
import TextInput from '@components/FormComponents/TextInput';
import { PurchaseData } from '@lib/types';
import { Dispatch, SetStateAction } from 'react';

const purchaserDetailsComponent = ({
    purchaseData,
    setPurchaseData,
}: {
    purchaseData: PurchaseData;
    setPurchaseData: Dispatch<SetStateAction<PurchaseData>>;
}) => {
    const handlePurchaserDetailsChange = (
        e: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const { name, value } = e.target;
        setPurchaseData((prev) => ({
            ...prev,
            purchaserDetails: {
                ...prev.purchaserDetails,
                [name]: value,
            },
        }));
    };

    const handleGiftChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;

        // if gift set to false, strip out recipient details to be safe
        if (!checked) {
            setPurchaseData((prev) => ({
                ...prev,
                gift: checked,
                recipientDetails: {
                    recipientName: '',
                    recipientEmail: '',
                    senderName: '',
                    message: '',
                },
            }));
        } else {
            setPurchaseData((prev) => ({
                ...prev,
                gift: checked,
            }));
        }
    };

    return (
        <div>
            <form id="purchaserDetailsForm">
                <TextInput
                    onChange={handlePurchaserDetailsChange}
                    id="purchaserName"
                    name="purchaserName"
                    title="Purchaser Name"
                    type="text"
                    placeholder="Enter your full name"
                    required={true}
                    autoComplete="name"
                    value={purchaseData.purchaserDetails.purchaserName || ''}
                />
                <TextInput
                    onChange={handlePurchaserDetailsChange}
                    id="purchaserEmail"
                    name="purchaserEmail"
                    title="Purchaser Email"
                    type="email"
                    placeholder="Enter your email address"
                    required={true}
                    autoComplete="email"
                    value={purchaseData.purchaserDetails.purchaserEmail || ''}
                />
                <TextInput
                    onChange={handlePurchaserDetailsChange}
                    id="purchaserPhone"
                    name="purchaserPhone"
                    title="Purchaser Phone Number"
                    type="tel"
                    placeholder="Enter your phone number"
                    required={true}
                    autoComplete="tel"
                    value={purchaseData.purchaserDetails.purchaserPhone || ''}
                />
                <Switch
                    id="switchinput"
                    name="switchinput"
                    title="Would you like to send this as a gift?"
                    required={true}
                    onChange={handleGiftChange}
                    checked={purchaseData.gift || false}
                />
            </form>
        </div>
    );
};

export default purchaserDetailsComponent;
